import $api from '@/utils/request'

// 根据ID查询ERP用户
export function getErpUserListById(id) {
  return $api({
    url: `/sunsky-erp-user-web/user/erp/entity/${id}`,
    method: 'get'
  })
}
// 根据ID查询SUNSKY用户
export function getSunskyUserListById(id) {
  return $api({
    url: `/sunsky-erp-user-web/user/entity/${id}`,
    method: 'get'
  })
}

// 是否登陆
export function getToken() {
  return $api({
    url: `/user/token`,
    method: 'get'
  })
}

// 推出登陆
export function loginOut() {
  return $api({
    url: '/mobilev2/user!logout.do',
    method: 'get'
  })
}
